import { render, staticRenderFns } from "./ContainerShell.vue?vue&type=template&id=5d95062c&scoped=true&"
import script from "./ContainerShell.vue?vue&type=script&lang=js&"
export * from "./ContainerShell.vue?vue&type=script&lang=js&"
import style0 from "./ContainerShell.vue?vue&type=style&index=0&id=5d95062c&prod&lang=scss&"
import style1 from "./ContainerShell.vue?vue&type=style&index=1&id=5d95062c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d95062c",
  null
  
)

export default component.exports